import axios from "axios";
import { useState, useEffect, useRef } from "react";
import {
  useNavigate,
  Navigate,
  useSearchParams,
  Outlet,
} from "react-router-dom";
import { toast } from "react-toastify";


// export const baseUrl = "http://192.168.1.16:8000/api/v1/";
// export const fileUrl = "http://192.168.1.16:8000/storage/";


export const baseUrl = "https://slamat-back.icrcompany.net/api/v1/";
export const fileUrl = "https://slamat-back.icrcompany.net/storage/";

//!=============================================================> post data login
export const useLOGIN = (initialState) => {
  const [formData, setFormData] = useState(initialState); // data
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // const navigate = useNavigate();
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (url) => {
    setLoading(true);
    setError("");
    const formDataToSend = new FormData();
    for (const [key, value] of Object.entries(formData)) {
      formDataToSend.append(key, value);
    }
    axios
      .post(`${baseUrl}${url}`, formDataToSend)
      .then((req) => {
        setLoading(false);
        setError("");
        localStorage.setItem("token", req?.data.data?.token);
        localStorage.setItem("role_name", req?.data.data?.admin?.role?.name);
        navigate("/");
      })
      .catch((e) => {
        setError(e.response?.data.errors);
        setLoading(false);
      });
  };
  //
  return { formData, handleChange, loading, error, handleSubmit, setFormData };
};
// !======================================================================================
export const usePOST = (initialState) => {
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [viewFile, setViewFile] = useState("");
  const [viewImages, setViewImages] = useState([]);
  const [images, setImages] = useState({});
  const [checkArray, setCheckArray] = useState({});
  const [dataPlayer, setDataPlayer] = useState();
  const [counter, setCounter] = useState(0);
  const [totalBalance, setTotalBalance] = useState("");
  const [successfulPost, setSuccessfulPost] = useState(0);

  // const navigate = useNavigate();
  //=====================================================> function change   data all
  const handleChangeInput = (event) => {
    const { name, value, type, files, checked } = event.target;
    const newValue =
      type === "file" ? files[0] : type === "checkbox" ? checked : value;
    type === "file" && setViewFile(URL.createObjectURL(newValue));

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: newValue === true ? 1 : newValue === false ? 0 : newValue,
    }));

  };
  //=====================================================>  function change  array images
  const handleChangeArrayImages = (event) => {
    const files = event.target.files;
    const newFilesObject = {};

    // Generate unique keys for new files
    const currentImagesCount = Object.keys(images).length;
    for (let i = 0; i < files.length; i++) {
      newFilesObject[`files[${currentImagesCount + i}]`] = files[i];
    }

    setImages((prevImages) => ({
      ...prevImages,
      ...newFilesObject,
    }));

    const urlImages = [];
    for (let i = 0; i < files.length; i++) {
      if (!files[i]) continue;
      urlImages.push({
        name: files[i].name,
        value: URL.createObjectURL(files[i]),
      });
    }

    setViewImages((prev) => [...prev, ...urlImages]);

    event.target.value = "";
  };

  //=====================================================> function change   array checkbox
  const handleCheckedArray = (e) => {
    const { value, checked, name } = e.target;
    if (checked) {
      setCheckArray({ ...checkArray, [name]: [value] });
      if (checkArray[name]) {
        setCheckArray({
          ...checkArray,
          [name]: [...checkArray[name], value],
        });
      }
    } else {
      if (checkArray[name]) {
        setCheckArray({
          ...checkArray,
          [name]: checkArray[name].filter((p) => p !== value),
        });
      }
    }
  };

  //=====================================================> post data
  const handleSubmit = async (url, route, noRoute, reload) => {
    setSuccessfulPost(0);
    setLoading(true);
    setError("");
    const formDataToSend = new FormData();
    for (const [key, value] of Object.entries(formData)) {
      formDataToSend.append(key, value);
    }
    for (const [key, value] of Object.entries(checkArray)) {
      for (let i = 0; i < value.length; i++) {
        formDataToSend.append(key, value[i]);
      }
    }
    for (const [key, value] of Object.entries(images)) {
      formDataToSend.append(key, value);
    }
    axios
      .post(`${baseUrl}${url}`, formDataToSend, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((req) => {
        setSuccessfulPost(1);
        setLoading(false);
        setError("");
        setDataPlayer(req);
          toast.success("تم ارسال رسالتك بنجاح");
        setTotalBalance(req?.data?.data?.total_balances);
        route
          ? navigate(route)
          : noRoute
            ? console.log("ss")
            : reload
              ? window.location.reload()
              : window.history.go(-1);
      })
      .catch((e) => {
        setError(e.response.data?.message);
        setLoading(false);
        setDataPlayer(e);
      });
  };
  return {
    formData,
    setFormData,
    viewFile, //  لعرض الصورة او فيديو .....
    setViewFile, // ((local)) لحذف الصورة
    viewImages, // لعرض الصور
    setViewImages, // ((local)) لحذف الصور
    images, //api  لأرسال الصور الى
    setImages, //api  لحذف الصور الى
    error,
    setError,
    loading,
    setLoading,
    handleChangeInput,
    handleCheckedArray,
    handleChangeArrayImages,
    handleSubmit,
    checkArray,
    setCheckArray,
    counter,
    setCounter,
    dataPlayer,
    totalBalance,
    successfulPost,
    setTotalBalance,
  };
};

//!=============================================================>start fetch data
export const useFETCH = (url, urlDelete) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isErroe, setIsError] = useState("");

  // const navigate = useNavigate();
  useEffect(() => {
    if (url) {
      setIsLoading(true);
      axios
        .get(`${baseUrl}${url}`, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            lms: "Mawahb"
          },
        })
        .then((req) => {
          if (req) {
            setData(req);
            setIsLoading(false);
            setIsError("");
          }
        })
        .catch((e) => {
          setIsLoading(false);
          setIsError("خطأ في جلب البيانات");
          if (e.request.status === 401) {
            navigate("/login");
            localStorage.clear();
          }
          if (e.request.status === 403) {
            navigate("/403");
          }
          if (e.request.status === 500) {
            navigate("/500");
          }
        });
    }
  }, [url]);

  //?=============================================================> deleteItem
  const deleteItem = async (e) => {
    setIsLoading(true);
    axios
      .delete(`${baseUrl}${urlDelete || url}/${e.id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((req) => {
        setIsLoading(false);
        setIsError("تم الحذف  بنجاح");
        window.location.reload();
      })
      .catch((e) => {
        setIsLoading(false);
        setIsError(" خطأ في الحذف  حاول مرة آخرى");
      });
  };
  return { data, isLoading, isErroe, deleteItem };
};
//=============================================================> end fetch data

const navigate = useNavigate;

export const logout = (url) => {
  axios
    .post(
      `${baseUrl}${url}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
    .then((req) => {
      localStorage.removeItem("token");
      window.location.reload();
      navigate("/login");
    })
    .catch((e) => { });
};

//?=============================================================> close items
export const useClose = () => {
  const [open, setOpen] = useState(false);
  const mouse = useRef();
  useEffect(() => {
    const handler = (e) => {
      if (mouse.current) {
        if (!mouse.current.contains(e.target)) {
          setOpen(false);
        }
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.addEventListener("mousedown", handler);
    };
  }, []);
  return { open, setOpen, mouse };
};
//!=============================================================> pagination or filter or search
export const useFilter = (params) => {
  const [filter, setFilter] = useSearchParams();
  const handlePageClick = (event) => {
    setFilter(
      params || {
        page: event.selected + 1,
        sort_value: filter.get("sort_value") ? filter.get("sort_value") : "",
        sort_by: filter.get("sort_by") ? filter.get("sort_by") : "",
        state: filter.get("state") ? filter.get("state") : "",
      }
    );
  };
  return { filter, handlePageClick, setFilter };
};
//!=============================================================> عدم دخول من غير تسجيل دخول
export const RequireAuth = () => {
  if (!window.localStorage.getItem("token")) {
    return <Navigate to="/login" />;
  }
  return <Outlet />;
};
//! =============================================================>عدم فتح صفحة تسجيل دخول اذا مسجل مسيقا
export const RequireLogin = () => {
  if (window.localStorage.getItem("token")) {
    return <Navigate to="/" />;
  }
  return <Outlet />;
};

// ==========================================================> شرط الصفحات المسموح الدخول اليها
export const RequireAdmin = ({ name }) => {
  if (name === localStorage.getItem("role_name")) {
    return <Navigate to="/403" />;
  }
  return <Outlet />;
};

//!=============================================================> تكبير الصورة
export const clickZoomInImage = (event) => {
  event.target.requestFullscreen();
};
// ==============================================================> صفحة التواصل
export const useContactUs = (url) => {
  const [loading, setLoading] = useState(false);
  const updateContactUs = (info_key, info_value, url) => {
    setLoading(true);
    axios
      .post(
        `${baseUrl}${url}`,

        {
          _method: "PUT",
          [`${info_key}`]: info_value,
        },

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((req) => {
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };
  return { updateContactUs, loading };
};
